import ViewModelService from './ViewModelService';
import 'gw-portals-metadata-angular';

export default angular.module('gw-portals-viewmodel-angular', ['gw-portals-metadata-angular'])
    .factory('ViewModelService', ViewModelService);